<template>
  <div>
    <v-layout
      row>
        <p class="accessIndex__text--title" >Correos electrónicos</p>
    </v-layout>
 
    <user-segments v-show="!stepActive" :users="myUsers" :mySection="userSection" :myCharacteristics="characteristics"  @finish="nextStep"></user-segments>
    <email-section v-if="stepActive" :users="myUsers" :unregistered_users="unregisteredUsers" @back="backStep"></email-section>

  </div>
</template>

<script>
const EmailSection = () => import('./Email_section')
const UserSegments = () => import('./../users/user_selector/Selector_controller')
export default {
  data(){
    return{
      stepActive:false,
      characteristics:[],
      myUsers:[],
      unregisteredUsers:[],
      userSection:0
    }
  },
  components: {
    EmailSection,
    UserSegments,
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    nextStep(myUsers,unregisteredUsers, myCharacteristics){
      console.log("Finish my Users");
      console.log(myUsers)
      console.log("Finish my UNREGISTERED User ");
      console.log(unregisteredUsers)
      this.myUsers=myUsers;
      this.unregisteredUsers=unregisteredUsers;
      this.stepActive=true;
      this.characteristics= myCharacteristics;
    },
    backStep(number){
      this.userSection=0;
      this.$nextTick().then(() => {
        if(number>0){
          this.userSection=1;
        }else{
          this.userSection=0;
        }
        this.stepActive=false;
      });
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/emails/New_email.vue